"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialBillingAddress = getInitialBillingAddress;
exports.submitOnClick = exports.hideAllFieldsExceptWidget = void 0;
var _validations = require("./validations");
var _commonUtils = require("../commonUtils");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Generates and returns a function that will listen for on-click event of the adyen button
 * @param customFunctions: Custom functions passed by the host application
 * @param checkoutComp: Adyen's checkout component
 * @param referenceContainer: contains references of all fields
 * @param setIsOtherInputFieldsValid: Sets a boolean value based on validity of fields other than adyen
 * @returns {function(...[*]=)}: Returns the onClick event handler function
 */
var submitOnClick = function submitOnClick(_ref) {
  var customFunctions = _ref.customFunctions,
    checkoutComp = _ref.checkoutComp,
    referenceContainer = _ref.referenceContainer,
    setIsOtherInputFieldsValid = _ref.setIsOtherInputFieldsValid,
    validateBillingAddressFields = _ref.validateBillingAddressFields,
    billingInfo = _ref.billingInfo;
  return (
    // eslint-disable-next-line no-unused-vars
    function (event) {
      var validator = function validator(referenceContainer) {
        return customFunctions['customValidate'] ? customFunctions['customValidate'](referenceContainer) && (0, _validations.validate)(referenceContainer) : (0, _validations.validate)(referenceContainer);
      };
      (0, _commonUtils.focusOnCustomFields)([referenceContainer['emailInputField'], referenceContainer['phoneInputField'], referenceContainer['nameInputField']]);
      validateBillingAddressFields(billingInfo);
      // Set the state with validation result for later use
      setIsOtherInputFieldsValid(validator(referenceContainer));
      //focus back to submit button
      referenceContainer['paymentSubmitBtn'].focus();
      //Scroll up to the payment window, don't let it go out of the screen
      document.getElementById('payment-page').scrollIntoView({
        behavior: 'smooth'
      });
      checkoutComp.submit();
      setTimeout(function () {
        checkoutComp.submit();
      }, 500);
    }
  );
};

/**
 * Helper function to hide all components except Adyen Widget
 * @param referenceContainer: Contains reference of all the components
 */
exports.submitOnClick = submitOnClick;
var hideAllFieldsExceptWidget = function hideAllFieldsExceptWidget(referenceContainer, billingContainerRef) {
  var hideField = function hideField(ref) {
    if (ref) {
      ref.style.display = 'none';
    }
  };
  hideField(referenceContainer['billingInfoHeader']);
  hideField(referenceContainer['emailInputField']);
  hideField(referenceContainer['phoneInputField']);
  hideField(referenceContainer['nameInputField']);
  hideField(referenceContainer['paymentSubmitBtn']);
  billingContainerRef && billingContainerRef.current && hideField(billingContainerRef.current);
  var paymentMethodList = document.getElementsByClassName('payment-checkout__payment-method');
  var _iterator = _createForOfIteratorHelper(paymentMethodList),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var paymentMethod = _step.value;
      if (!paymentMethod.classList.contains('payment-checkout__payment-method--selected')) {
        paymentMethod.style.display = 'none';
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
exports.hideAllFieldsExceptWidget = hideAllFieldsExceptWidget;
function getInitialBillingAddress() {
  var preSelectedCountry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var preSelectedState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    country: {
      value: preSelectedCountry || 'US',
      error: ''
    },
    zipCode: {
      value: '',
      error: ''
    },
    addressLine: {
      value: '',
      error: ''
    },
    addressLineTwo: {
      value: '',
      error: ''
    },
    city: {
      value: '',
      error: ''
    },
    state: {
      value: preSelectedState,
      error: ''
    }
  };
}